module.exports = __webpack_public_path__ + "img/scene_4.fe1310ac.jpg";